/**
 * Zod Validation Schema for Credit Package Form
 */

import { z } from 'zod';

// Package Form Schema
export const packageFormSchema = z.object({
  // Basic Information
  package_code: z
    .string()
    .min(2, 'รหัสแพ็กเกจต้องมีอย่างน้อย 2 ตัวอักษร')
    .max(20, 'รหัสแพ็กเกจต้องไม่เกิน 20 ตัวอักษร')
    .regex(/^[a-z0-9_-]+$/, 'ใช้ได้เฉพาะตัวอักษรภาษาอังกฤษตัวเล็ก ตัวเลข และ _ - เท่านั้น'),
  
  name: z
    .string()
    .min(2, 'ชื่อแพ็กเกจต้องมีอย่างน้อย 2 ตัวอักษร')
    .max(100, 'ชื่อแพ็กเกจต้องไม่เกิน 100 ตัวอักษร'),
  
  description: z
    .string()
    .trim()
    .min(1, 'กรุณากรอกคำอธิบายแพ็กเกจ')
    .max(500, 'คำอธิบายต้องไม่เกิน 500 ตัวอักษร'),
  
  is_active: z.boolean().default(true),
  
  sort_order: z
    .number()
    .int()
    .min(0, 'ลำดับต้องเป็นตัวเลขบวก')
    .max(100, 'ลำดับต้องไม่เกิน 100')
    .default(50),

  // Pricing (with coercion for form inputs)
  monthly_price: z.coerce
    .number()
    .min(0, 'ราคาต้องไม่ติดลบ')
    .max(1000000, 'ราคาต้องไม่เกิน 1,000,000'),
  
  monthly_price_usd: z.coerce
    .number()
    .min(0, 'ราคาต้องไม่ติดลบ')
    .max(100000, 'ราคาต้องไม่เกิน 100,000')
    .optional()
    .catch(undefined),  // Convert null to undefined
  
  included_credits: z.coerce
    .number()
    .int()
    .min(-1, 'จำนวนเครดิตต้องเป็นตัวเลขบวกหรือ -1 สำหรับไม่จำกัด'),
  
  overage_rate: z.coerce
    .number()
    .min(0, 'อัตราเครดิตเพิ่มต้องไม่ติดลบ')
    .max(1000, 'อัตราเครดิตเพิ่มต้องไม่เกิน 1,000'),
  
  overage_rate_usd: z.coerce
    .number()
    .min(0, 'อัตราเครดิตเพิ่มต้องไม่ติดลบ')
    .max(100, 'อัตราเครดิตเพิ่มต้องไม่เกิน 100')
    .optional()
    .catch(undefined),  // Convert null to undefined
  
  max_credit_purchase: z.coerce
    .number()
    .int()
    .min(-1, 'จำนวนเครดิตสูงสุดต้องเป็นตัวเลขบวกหรือ -1 สำหรับไม่จำกัด')
    .max(1000000, 'จำนวนเครดิตสูงสุดต้องไม่เกิน 1,000,000'),
  
  credit_expiry_period: z
    .string()
    .min(1, 'กรุณาเลือกระยะเวลาหมดอายุ'),

  // Features & Permissions
  features: z
    .array(z.string())
    .min(0, 'กรุณาระบุฟีเจอร์'),
  
  permissions: z
    .array(z.string())
    .min(0, 'กรุณาระบุสิทธิ์'),
});

export type PackageFormValues = z.infer<typeof packageFormSchema>;
